import { useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';
import { useState, useEffect } from 'react';
import "./../styles/AddPaymentMethod.css";

const AddPaymentMethod = ({ clientSecret, onAddingCardComplete, cancelClicked }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [cardholderName, setCardholderName] = useState('');
  
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;
    
        // 1) Submit the Payment Element first
        const { error: submitError } = await elements.submit();
        if (submitError) {
          setError(submitError.message);
          return;
        }
    
        // 2) Now confirm the SetupIntent
        const { error: setupError, setupIntent } = await stripe.confirmSetup({
          elements,
          clientSecret,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: cardholderName,
              },
            },
          },
          redirect: 'if_required',
        });
    
        if (setupError) {
          setError(setupError.message);
        } else {
          // The new card is now attached to the customer
          onAddingCardComplete(setupIntent.payment_method);
        }
      };
  
    return (
      <form onSubmit={handleSubmit} className='payment-form'>
        <input
          type="text"
          placeholder="Cardholder Name"
          value={cardholderName}
          onChange={(e) => setCardholderName(e.target.value)}
          required
          className="payment-input"
        />

        <PaymentElement />
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <div className="add-payment-method-buttons">
          <button type="submit" className='cancel-button-add-payment-method' disabled={!stripe || !elements }>
            Save Card
          </button>
          <button type="button" className='cancel-button-add-payment-method' onClick={cancelClicked}>Cancel</button>
        </div>
      </form>
    );
  }

  export default AddPaymentMethod;